import React from 'react';

import classNames from "classnames";
import styles from "../styles/betting-zone.drawer-menu.module.scss"
import {observer} from "mobx-react";
import {useThemeColor} from "../../../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../../../../core/app/consts/colors";
import {KeyboardArrowLeft} from "../../../../../core/icons/keyboard-arrow/keyboard-arrow-left";
import {KeyboardArrowRight} from "../../../../../core/icons/keyboard-arrow/keyboard-arrow-right";

export const BettingZoneDrawerMenuBackButton = observer(({
                                                             controller,
                                                             navigate
                                                           }) => {
  const {device, terms} = controller;
  const {isRtl} = device;
  const {WIDGETS_BACK} = terms;

  const backButtonProps = {
    className: classNames(styles.back_button),
    onClick: () => navigate(-1),
  }

  const arrowColor = useThemeColor(COLORS.whitePrimary)
  const arrowProps = {
    color: arrowColor,
    style: {
      fill: arrowColor,
      width: 24,
      height: 24
    }
  }

  return <div {...backButtonProps}>
    {
      isRtl ? <KeyboardArrowRight {...arrowProps}/> : <KeyboardArrowLeft {...arrowProps}/>
    }
    {WIDGETS_BACK}
  </div>
});
